import { IContentfulFeature } from '../../../../types/contentful/feature'
import { Entry } from 'contentful'
import { mapContentfulImageAsset } from '@utils/contentful/contentfulImage'
import { IConfigurableFeature } from 'app/_components/ContentfulPage/ConfigurableFeatures/features.types'

export const parseFeature = (
  contentfulFeature: Entry<IContentfulFeature>
): IConfigurableFeature => {
  const feature = {
    id: contentfulFeature?.sys?.id,
    submenuLabel: contentfulFeature?.fields?.submenuLabel,
    componentKey: 'feature',
    imageSide: contentfulFeature?.fields?.layout,
    backgroundColor: contentfulFeature?.fields?.backgroundColor,
    image: mapContentfulImageAsset(contentfulFeature?.fields?.image),
    imageSize: contentfulFeature?.fields?.imageSize,
    videoUrl: contentfulFeature?.fields?.video?.fields?.file?.url,
    title: contentfulFeature?.fields?.title,
    titleColor: contentfulFeature?.fields?.titleColor,
    titleSize: contentfulFeature?.fields?.titleSize,
    subtitle: contentfulFeature?.fields?.subtitle,
    subtitleColor: contentfulFeature?.fields?.subtitleColor,
    description: contentfulFeature?.fields?.description,
    ctaColor: contentfulFeature?.fields?.ctaColor,
    ctaType: contentfulFeature?.fields?.ctaType,
    ctaLabel: contentfulFeature?.fields?.ctaLabel,
    ctaBtnVariant: contentfulFeature?.fields?.ctaBtnVariant,
    ctaLink: contentfulFeature?.fields?.ctaLink,
    ctaEventId: contentfulFeature?.fields?.ctaEventId,
    componentUniqueKey: contentfulFeature?.fields?.componentUniqueKey,
    className: '',
    streamingVideo: contentfulFeature?.fields?.streamingVideo?.fields,
  }
  return feature
}
